module.exports = __webpack_public_path__ + "static/media/2025-The-Debrief-Feature-Banner-sm@1x.d9e83f15.jpg";